// extracted by mini-css-extract-plugin
module.exports = {"terms":"-nXwX_5r"};